import { initSubRoutes } from '../../../../../utils/router';

const RoutesVisualiserTitreDetention = initSubRoutes({
    route: '/visualiser/:uuid',
    subroutes: {},
    nom: 'Visualiser un titre de détention',
});

export default RoutesVisualiserTitreDetention;
